import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import authentication from './authentication'
import topics from './topics'
import questions from './questions'
import formulations from './formulations'
import tests from './tests'
import users from './users'
import teachings from './teachings'
import subjects from './subjects'
import titles from './titles'

Vue.use(Vuex)

axios.defaults.baseURL = '/api' // Production

export default new Vuex.Store({
    modules:{
        authentication,
        topics,
        questions,
        formulations,
        tests,
        users,
        teachings,
        subjects,
        titles,
    },

    state: {
        snackBar: {
            value: false,
            text: '',
            color: '',
        },
        knowledgeArea: "",
        loading: 0,
    },

    getters: {
        getSnackBar(state){ return state.snackBar },
        getKnowledgeArea(state){ return state.knowledgeArea },
        isLoading(state) { return state.loading > 0 },
    },

    mutations: {
        setSnackBar(state, value){ state.snackBar = value },
        setKnowledgeArea(state, value){ state.knowledgeArea = value },
        setLoading(state){ state.loading += 1},
        unsetLoading(state){ state.loading -= 1},
    },

    actions: {
        getKnowledgeArea({ commit }){
            commit('setLoading')
            return new Promise(() => {
                axios.get('/knowledgeArea')
                .then((response) =>{
                    commit('setKnowledgeArea', response.data)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },
    }
})
